<template>
  <div class="relative">
    <div class="absolute insights-bg md:block lg:block hidden">
      <img
        src="../../../../assets/images/line/insig-line.svg"
        alt="bg-polygon"
        class="h-full w-full"
      />
    </div>
    <div class="absolute insights-bg-mob md:hidden lg:hidden block">
      <img
        src="../../../../assets/images/line/inst-news-bg-mob.svg"
        alt="bg-polygon"
        class="h-full w-full"
      />
    </div>
    <div
      class="
        md:w-4/5
        lg:w-4/5
        w-full
        md:px-0
        lg:px-0
        px-4
        mx-auto
        md:pt-32
        lg:pt-32
        pt-6
      "
    >
      <div class="flex justify-between items-center my-12">
        <p
          class="
            title
            fsize36-16px-isg
            z-10
            lg:font-normal
            md:font-normal
            font-bold
          "
        >
          Latest Events
        </p>
        <div class="md:block lg:block hidden">
          <div class="flex text-black">
            <b-form-select
              v-model="selectedDis"
              :options="Events"
              class="
                mr-4
                border-2 border-primary
                text-base text-primary
                font-medium
              "
            ></b-form-select>
            <b-form-select
              v-model="selectedSeg"
              :options="Platforms"
              class="
                mr-4
                border-2 border-primary
                text-base text-primary
                font-medium
              "
            ></b-form-select>
            <b-form-select
              v-model="selectedUsers"
              :options="Users"
              class="border-2 border-primary text-base text-primary font-medium"
            ></b-form-select>
          </div>
        </div>
      </div>

      <div
        class="
          ht40rem-res
          border-t-2 border-b-2
          bg-white
          rounded-lg
          relative
          cust-overflow-y-primary-color-grey
        "
      >
        <div class="w-full border-b-2 pt-4 pl-3 md:h-52 lg:h-52 h-36">
          <p class="cal2-date">1 Mar, 2021 Monday</p>
        </div>
        <div class="w-full border-b-2 pt-4 pl-3 md:h-52 lg:h-52 h-36">
          <p class="cal2-date">2 Mar, 2021 Monday</p>
        </div>
        <div class="w-full border-b-2 pt-4 pl-3 md:h-52 lg:h-52 h-36">
          <p class="cal2-date">3 Mar, 2021 Monday</p>
          <p class="pt-6 cal2-event">Lorem Ipsum Dolor Sit Amet</p>
          <p class="cal2-event-desc">
            Phasellus nec feugiat vitae, pharetra venenatis volutpat egestas
            aliquet. Risus amet veli.
          </p>
        </div>
        <div class="w-full border-b-2 pt-4 pl-3 md:h-52 lg:h-52 h-36">
          <p class="cal2-date">4 Mar, 2021 Monday</p>
        </div>
        <div class="w-full border-b-2 pt-4 pl-3 md:h-52 lg:h-52 h-36">
          <p class="cal2-date">5 Mar, 2021 Monday</p>
        </div>
        <div class="w-full border-b-2 pt-4 pl-3 md:h-52 lg:h-52 h-36">
          <p class="cal2-date">6 Mar, 2021 Monday</p>
        </div>
        <div class="w-full border-b-2 pt-4 pl-3 md:h-52 lg:h-52 h-36">
          <p class="cal2-date">7 Mar, 2021 Monday</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value: "",
      context: null,
      selectedDis: null,
      selectedUsers: null,
      selectedSeg: null,
      Events: [
        { value: null, text: "Events", disabled: true },
        { value: "d", text: "Webinars" },
        { value: "a", text: "Workshops" },
        { value: "b", text: "Conversations" },
        { value: "c", text: "Summits" },
      ],
      Platforms: [
        { value: null, text: "Platforms", disabled: true },
        { value: "d", text: "Zoom" },
        { value: "d", text: "Mentza" },
        { value: "e", text: "Clubhouse" },
        { value: "f", text: "Offline" },
      ],
      Users: [
        { value: null, text: "For Whom", disabled: true },
        { value: "d", text: "Caregiver" },
        { value: "g", text: "Well-Wisher" },
        { value: "h", text: "Healthcare Professional" },
        { value: "i", text: "Corporate" },
      ],
    };
  },
  methods: {
    onContext(ctx) {
      this.context = ctx;
    },
  },
};
</script>
<style>
.w-full-cust > .b-calendar-inner {
  width: 100% !important;
}
.cust-cal2 > .b-calendar-inner > .b-calendar-grid > .b-calendar-grid-help {
  display: none;
}
.cust-cal2 > .b-calendar-inner > .b-calendar-grid {
  border: none;
  /* background-color: white !important; */
  padding: 0% !important;
}
.cust-cal2 > .b-calendar-inner > .b-calendar-nav {
  width: 25%;
  margin-left: auto;
  /* margin-right: auto; */
  margin-bottom: -3.5rem;
  padding-top: 20px;
}
.cust-cal2 > .b-calendar-inner > .b-calendar-grid > header {
  font-size: 39px;
  font-style: normal;
  font-weight: 700;
  line-height: 53px;
  letter-spacing: 0em;
  text-align: left !important;
  padding-bottom: 2rem;
  background-color: transparent;
}
/* .cust-cal2
  > .b-calendar-inner
  > .b-calendar-grid
  > .b-calendar-grid-body
  > .row {
  height: 8rem;
} */
.cust-cal2
  > .b-calendar-inner
  > .b-calendar-grid
  > .b-calendar-grid-body
  > .row
  > .col {
  border: 1px solid #e9ecef;
  /* background-color: white !important; */
}
.cust-cal2
  > .b-calendar-inner
  > .b-calendar-grid
  > .b-calendar-grid-body
  > .row
  > .col
  > span {
  display: flex;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
  padding-top: 1rem;
  padding-bottom: 6rem;
  padding-left: 1rem;
  border-radius: 1px !important;
}
/* .cust-cal2
  > .b-calendar-inner
  > .b-calendar-grid
  > .b-calendar-grid-body
  > .row
  > .col
  > .btn-primary:not(:disabled):not(.disabled).active {
  background-color: red !important;
} */
.cust-cal2
  > .b-calendar-inner
  > .b-calendar-grid
  .b-calendar-grid-weekdays
  > small {
  padding-top: 15px;
  padding-bottom: 15px;
  padding-left: 15px;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: left;
  border: 1px solid #e9ecef;
}
.cust-cal2 > .b-calendar-inner > .b-calendar-grid .b-calendar-grid-weekdays {
  background-color: transparent !important;
}
.cust-cal2
  > .b-calendar-inner
  > .b-calendar-nav
  .btn-outline-secondary
  > div
  > .bi {
  margin-left: auto;
  margin-right: auto;
  height: 35px;
}
</style>
